<template>
	<div id="shop">
		<div class="section">
			<div class="library-info">
				<h3 style="font-size:2em; text-align: center;">Acquista in modo sicuro e veloce uno dei nostri pacchetti</h3>
			</div>
		</div>

		<div class="section">
			<div class="contmenublog">
			<div class="menublog">
				<div class="filtro">
					<div class="catcont">
						<div class="menu-button">
						<button @click="bShowBlogNav = !bShowBlogNav"><div class="fas fa-bars fa-fw"></div></button>
						</div>
						<div class="categoria">
							<router-link class="link" to="#class">Small Class</router-link>
						</div>
						<div class="categoria">
							<router-link class="link" to="#eximusdaita">EXIMUS+DAITA</router-link>
						</div>

						<div class="mobileblog" :class="{'show': bShowBlogNav}" @click="bShowBlogNav = false">
							<div class="mobile-nav">
								<router-link class="link t-uppercase" to="#class">Small Class</router-link>
								<router-link class="link t-uppercase" to="#eximusdaita">EXIMUS+DAITA</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		<!--	<div class="divprova" style="padding:0; margin-bottom:-3.5em;">
				<a href="#eximusdaita"><button class="provagratuita" id="class" style="max-width:100%; width:70%;">Scopri i pacchetti che abbiamo ideato con il nostro nutrizionista!</button></a>
			</div>-->
		</div>

		<div class="section">
			<div class="container-desktop pad-l">
				<h2 class="section-title" id="class">Pacchetti Small Class</h2>
				<div class="p-relative">
						<div class="bar2">
							<Card class="bg-darker" title="10 lezioni small class" :image="require('@/assets/sc.jpg')"><p>Pacchetto 10 lezioni small class, nessun vincolo e nessuna scadenza.<br>(Ricorda di utlizzare la stessa email che usi per iscriverti alle classi!)</p><p class="prezzo">150€</p><p class="buy"><a href="https://buy.stripe.com/8wMeX2dhD7jdf724gh"><button>Acquista</button></a></p></Card>
							<Card class="bg-darker" title="20 lezioni small class" :image="require('@/assets/sc.jpg')"><p>Pacchetto 20 lezioni small class, nessun vincolo e nessuna scadenza.<br>(Ricorda di utlizzare la stessa email che usi per iscriverti alle classi!)</p><p class="prezzo">250€</p><p class="buy"><a href="https://buy.stripe.com/dR68yE1yVdHB1gc4gi"><button>Acquista</button></a></p></Card>
						</div>
				</div>
			</div>
			<div class="container-desktop pad-l">
				<h2 class="section-title" id="class">Abbonamenti Small Class</h2>
				<div class="p-relative">
						<div class="bar">
							<Card class="bg-darker" title="3 mesi small class" :image="require('@/assets/sc.jpg')"><p>Allenati quante volte vuoi senza limiti di ingressi!<br>(Ricorda di utlizzare la stessa email che usi per iscriverti alle classi!)</p><br><p class="center">Paga subito l'intero importo</p><br><p class="prezzo">420€</p><p class="buy"><a href="https://buy.stripe.com/3cs6qw6TfdHB3ok8x9"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 3 pagamenti mensili</p><p class="prezzo">140€/mese</p><p class="buy"><a href="https://buy.stripe.com/28o9CI0uRdHB5ws14G"><button>Acquista</button></a></p></Card>
							<Card class="bg-darker" title="6 mesi small class" :image="require('@/assets/sc.jpg')"><p>Allenati quante volte vuoi senza limiti di ingressi!<br>(Ricorda di utlizzare la stessa email che usi per iscriverti alle classi!)</p><br><p class="center">Paga subito l'intero importo</p><br><p class="prezzo">800€</p><p class="buy"><a href="https://buy.stripe.com/28o0281yV0UPe2Y3cR"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 6 pagamenti mensili</p><p class="prezzo">135€/mese</p><p class="buy"><a href="https://buy.stripe.com/8wM5ms0uReLFaQM5kT"><button>Acquista</button></a></p></Card>
							<Card class="bg-darker" title="12 mesi small class" :image="require('@/assets/sc.jpg')"><p>Allenati quante volte vuoi senza limiti di ingressi!<br>(Ricorda di utlizzare la stessa email che usi per iscriverti alle classi!)</p><br><p class="center">Paga subito l'intero importo e <b style="color:#ffe010;">risparmia 60€!</b></p><br><p class="prezzo">1500€</p><p class="buy"><a href="https://buy.stripe.com/8wM3ekcdzcDx6Aw14K"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 12 pagamenti mensili</p><p class="prezzo">130€/mese</p><p class="buy"><a href="https://buy.stripe.com/14AfZg0y94dE6D62wr87K0L"><button>Acquista</button></a></p></Card>
						</div>
				</div>
			</div>
		</div>

		<div class="container-desktop pad-l">
			<h2 class="section-title" id="eximusdaita">Personal Training e Nutrizionista</h2>
			<div class="p-relative">
					<div class="bar">
						<Card class="bg-darker" title="3 mesi personal training+nutrizionista" :image="require('@/assets/eximusdaitapt.png')"><p>Il pacchetto include 2 lezioni di personal training a settimana e 3 visite con il nostro nutrizionista.</p><p>In regalo il kit eximus!</p><br><p class="center">Paga subito l'intero importo</p><br><p class="prezzo">1250€</p><p class="buy"><a href="https://buy.stripe.com/00gbKQ4L78nh9MI6ow"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 3 pagamenti mensili</p><p class="prezzo">420€/mese</p><p class="buy"><a href="https://buy.stripe.com/00g16c6Tf9rl2kg9AH"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker" title="6 mesi personal training+nutrizionista" :image="require('@/assets/eximusdaitapt.png')"><p>Il pacchetto include 2 lezioni di personal training a settimana e 6 visite con il nostro nutrizionista.</p><p>In regalo il kit eximus!</p><br><p class="center">Paga subito l'intero importo e <b style="color:#ffe010;">risparmia 100€!</b></p><p class="prezzo">2270€</p><p class="buy"><a href="https://buy.stripe.com/00g6qw1yV6f91gc28u"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 6 pagamenti mensili</p><p class="prezzo">395€/mese</p><p class="buy"><a href="https://buy.stripe.com/14k0282CZeLFbUQ8wH"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker" title="12 mesi personal training+nutrizionista" :image="require('@/assets/eximusdaitapt.png')"><p>Il pacchetto include 2 lezioni di personal training a settimana e 12 visite con il nostro nutrizionista.</p><p>In regalo il kit eximus!</p><br><p class="center">Paga subito l'intero importo e <b style="color:#ffe010;">risparmia 150€!</b></p><p class="prezzo">4170€</p><p class="buy"><a href="https://buy.stripe.com/5kAdSY0uR7jd0c83cx"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 12 pagamenti mensili</p><p class="prezzo">360€/mese</p><p class="buy"><a href="https://buy.stripe.com/4gwg1691n7jd3ok9AM"><button>Acquista</button></a></p></Card>
					</div>
						<h2 class="section-title" id="">Small Class e Nutrizionista</h2>
					<div class="bar">	
						<Card class="bg-darker" title="3 mesi small class+nutrizionista" :image="require('@/assets/eximusdaitaclass.png')"><p>Il pacchetto include tutte le classi che vuoi a settimana e 3 visite con il nostro nutrizionista.</p><br><p class="center">Paga subito l'intero importo</p><br><p class="prezzo">630€</p><p class="buy"><a href="https://buy.stripe.com/dR60282CZbztf7228o"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 3 pagamenti mensili</p><p class="prezzo">210€/mese</p><p class="buy"><a href="https://buy.stripe.com/14kbKQ2CZfPJe2YfZb"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker" title="6 mesi small class+nutrizionista" :image="require('@/assets/eximusdaitaclass.png')"><p>Il pacchetto include tutte le classi che vuoi a settimana e 6 visite con il nostro nutrizionista.</p><br><p class="center">Paga subito l'intero importo e <b style="color:#ffe010;">risparmia 100€!</b></p><p class="prezzo">1075€</p><p class="buy"><a href="https://buy.stripe.com/8wM02891nbzt7EA6oI"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 6 pagamenti mensili</p><p class="prezzo">196€/mese</p><p class="buy"><a href="https://buy.stripe.com/aEU028gtPdHB8IE4gu"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker" title="12 mesi small class+nutrizionista" :image="require('@/assets/eximusdaitaclass.png')"><p>Il pacchetto include tutte le classi che vuoi a settimana e 12 visite con il nostro nutrizionista.</p><br><p class="center">Paga subito l'intero importo e <b style="color:#ffe010;">risparmia 150€!</b></p><p class="prezzo">2000€</p><p class="buy"><a href="https://buy.stripe.com/5kA9CI3H3471bUQ7sL"><button>Acquista</button></a></p><p class="center">Dividi l'importo in 12 pagamenti mensili</p><p class="prezzo">180€/mese</p><p class="buy"><a href="https://buy.stripe.com/8wM4iob9vfPJf723cr"><button>Acquista</button></a></p></Card>
					</div>
			</div>
		</div>
		</div>

		<!--<div class="section">
			<div class="container-desktop pad-l">
				<h2 class="section-title" id="pt">Personal Training</h2>
				<div class="p-relative">
						<div class="bar2">
							<Card class="bg-darker" title="10 lezioni Personal Training singolo" :image="require('@/assets/pt_service.jpg')"><p>Pacchetto 10 lezioni Personal Training singolo, nessun vincolo e nessuna scadenza.<br><br><i class="fas fa-dollar-sign"></i> 400€<br><br><a href="">Acquista</a></p></Card>
							<Card class="bg-darker" title="20 lezioni Personal Training singolo" :image="require('@/assets/pt_service.jpg')"><p>Pacchetto 20 lezioni Personal Training singolo, nessun vincolo e nessuna scadenza.<br><br><i class="fas fa-dollar-sign"></i> 750€<br><br><a href="">Acquista</a></p></Card>
							<Card class="bg-darker" title="10 lezioni Personal Training di coppia" :image="require('@/assets/pt_service.jpg')"><p>Pacchetto 10 lezioni Personal Training di coppia, nessun vincolo e nessuna scadenza.<br><br><i class="fas fa-dollar-sign"></i> 500€<br><br><a href="">Acquista</a></p></Card>
							<Card class="bg-darker" title="20 lezioni Personal Training di coppia" :image="require('@/assets/pt_service.jpg')"><p>Pacchetto 20 lezioni Personal Training di coppia, nessun vincolo e nessuna scadenza.<br><br><i class="fas fa-dollar-sign"></i> 850€<br><br><a href="">Acquista</a></p></Card>
						</div>
					</div>
			</div>
		</div>-->

	
	</div>

</template>
<script>
import VideoCard from '@/components/library/VideoCard'
import Card from '@/components/home/Cardshop'
import About from '@/components/home/About'

export default {
	name: 'shop',

	components: {
		Card,
		About
	},

	data() {

		return {
			/// Authenticated user
			bShowBlogNav: false
		}
	},

	created(){
     },

	computed: {
		/**
		 * 
		 */
	},

	methods: {
		/**
		 * 
		 */
	},

	mounted() {

		window.scrollTo(0, 0)
	},

}

</script>

<style lang="stylus" scoped>

.bar
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.bar2
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(767, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 520px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(767, px))
		width 100%
		display grid

.menu-button
			height 100%
			margin 0 auto
			display none 

			@media (min-width: unit(768, px))
				display none

			>button
				height 100%

				display flex
				align-items center

				border none

				background-color transparent
				color #dcdcdc

				font-size 2em

				&:focus
					outline none
				&:hover
					background-color mix(darkish, dark)

.mobileblog
	display none

	&.show
		display none

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

	@media (max-width: unit(767, px))
		color red	

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease

.link:hover
	color #ffe010


.up
	position fixed
	bottom 0
	left 0
	margin-left 1em
	margin-bottom 1em
	width 2.5em
	height 2.5em
	border-radius 2.5em
	background #ffe010
	z-index 9999

.progselect
	max-width 570px
	margin 0 auto
	text-align center

	.progworkout
		max-width 490px
		margin 0 auto
		p
			text-align left
			font-size 1.2 em
			margin-left 0.7em

.divprogramma
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	@media (max-width: unit(560, px))
		grid-template-columns auto

.programma
	padding 0.4em 0.6em
	border none
	border-bottom 2px solid transparent
	box-sizing border-box
	background-color darkish
	color light
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 500px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.presdesc
	list-style-type none

	li:before
		content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
		color: #ffe010; /* Change the color */
		font-weight: bold; /* If you want it to be bold */
		display: inline-block; /* Needed to add space between the bullet and the text */
		width: 1em; /* Also needed for space (tweak if needed) */
		margin-left: -1em; /* Also needed for space (tweak if needed) */

.divpres
	text-align center

	img
		display block
		margin 0 auto

.divbox
	display grid
	grid-template-columns auto
	grid-gap 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto
	
	ul
		text-transform uppercase
		font-weight bold

.divul
	text-align left
	margin 0 auto
</style>
